let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hEuBm")).then(() => parcelRequire('79NFk'));